/*@flow*/
export default {
  LOCATION_DETAILS: 'LOCATION_DETAILS',
  LIST_VIEW: 'LIST_VIEW', // Alias for LOCATION_DETAILS
  FILTERS: 'FILTERS',
  LAYERS: 'LAYERS',
  ANALYSIS: 'ANALYSIS',
  PUBLIC_DATA: 'PUBLIC_DATA',
  TUTORIAL: 'TUTORIAL',
};
